import React from 'react';

import { Box } from '@mui/material';

import { PageLayout } from 'src/components/common';
import { EmployersTable } from 'src/components/employer';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { useCurrentUserPermissions } from 'src/hooks/user';
import {
  InviteEmployersAdminsByCVAdminModal,
  InviteEmployersAdminsByPeoStaffModal,
} from 'src/modals/employer';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const EmployersPage: React.FC = () => {
  const { hasPlatformRoles, hasPeoRoles } = useCurrentUserPermissions();

  return (
    <React.Fragment>
      <Box sx={containerStyles}>
        <TableDataProvider>
          <PageLayout titleContent="Employers" paperSx={pageLayoutPaperSx}>
            <EmployersTable />
          </PageLayout>
        </TableDataProvider>
      </Box>

      {hasPlatformRoles && <InviteEmployersAdminsByCVAdminModal />}
      {hasPeoRoles && <InviteEmployersAdminsByPeoStaffModal />}
    </React.Fragment>
  );
};

const containerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};
